// ToggleContext.js
import { createContext, useContext, useEffect, useState } from "react";

const ToggleContext = createContext();

export const ToggleProvider = ({ children }) => {
  const [isCareplanExpand, setIsCareplanExpand] = useState(false);
  const [isCurrentMonthCareplanExists, setIsCurrentMonthCareplanExists] =
    useState(false);
  const [careplanMode, setCareplanMode] = useState("new");

  // useEffect(() => {
  //   console.log(
  //     "wit toggle hook - isCareplanExpand:",
  //     isCareplanExpand,
  //     ", isCurrentMonthCareplanExists:",
  //     isCurrentMonthCareplanExists
  //   );
  // }, [isCurrentMonthCareplanExists, isCareplanExpand]);

  return (
    <ToggleContext.Provider
      value={{
        isCareplanExpand,
        setIsCareplanExpand,
        isCurrentMonthCareplanExists,
        setIsCurrentMonthCareplanExists,
        careplanMode,
        setCareplanMode,
      }}
    >
      {children}
    </ToggleContext.Provider>
  );
};

export const useToggle = () => useContext(ToggleContext);
